import { useCallback } from 'react';

import { useProjectActions } from 'src/store';
import { useBrandVoices } from 'src/services';
import { BACKEND_BRAND_VOICE_GENERATION_KEY } from 'src/data/brandVoice';

export const useHandlers = ({ onClose, onSubmit, onUpdatedCallback }) => {
  const projectActions = useProjectActions();
  const brandVoices = useBrandVoices();

  const handleSubmit = useCallback(
    async ({ brandVoiceId, generationTool, type, applyAll }) => {
      const bv = brandVoices.find((bv) => bv.id === brandVoiceId);

      //Blog builder
      if (onSubmit) {
        onSubmit(bv, applyAll);
        onClose?.();
        return;
      }

      await projectActions.updateProjectBrandVoice({
        brandVoiceId,
        generationTool,
        key: applyAll ? undefined : BACKEND_BRAND_VOICE_GENERATION_KEY[type],
        updateAll: applyAll,
      });

      onUpdatedCallback?.();
      onClose?.();
    },
    [onClose, projectActions, brandVoices, onSubmit, onUpdatedCallback]
  );

  return { handleSubmit };
};
